import React, { useState, useEffect } from "react";
import { Box, Checkbox, makeStyles, capitalize, Typography } from "@material-ui/core";
import { Highlight } from "react-instantsearch-dom";
import { getCommercialCategoryShortName } from "data/categories";
import Drawer from "./Drawer";

export default function RefinementList({
  title,
  items,
  isFromSearch,
  refine,
  createURL,
  searchForItems,
  searchable,
  hidden,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [itemsSelectedCount, setItemsSelectedCount] = useState(0);
  const limit = items?.filter((item) => item.isRefined).length > 4 ? items.filter((item) => item.isRefined).length : 4;
  const itemsToDisplay = expanded ? items : items?.slice(0, limit);

  useEffect(() => {
    setItemsSelectedCount(items.filter((item) => item.isRefined).length);
  }, [items, title]);

  return (items?.length || searchable) && !hidden ? (
    <Drawer title={title} itemsSelectedCount={itemsSelectedCount}>
      <Box py={3}>
        {searchable && (
          <input
            className={classes.search}
            type="search"
            placeholder="Rechercher"
            onChange={(event) => searchForItems(event.currentTarget.value)}
          />
        )}
        {itemsToDisplay.map((item) => (
          <Box
            key={item.label}
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            <Checkbox
              checked={item.isRefined}
              href={createURL(item.value)}
              style={{ fontWeight: item.isRefined ? "bold" : "" }}
              className={classes.checkbox}
            />
            <span>
              {isFromSearch ? (
                <Highlight attribute="label" hit={item} />
              ) : title === "Apparence de l'appareil" ? (
                getCommercialCategoryShortName(item)
              ) : (
                capitalize(item.label)
              )}
            </span>
            <Typography variant="caption" className={classes.itemCount}>
              {`${item.count}`}
            </Typography>
          </Box>
        ))}
        {items.length > 4 && (
          <>
            {expanded ? (
              <span
                className={classes.expandButton}
                onClick={() => setExpanded(false)}
                role="button"
                onKeyDown={() => {}}
                tabIndex={0}
              >
                Moins -
              </span>
            ) : (
              <span
                className={classes.expandButton}
                onClick={() => setExpanded(true)}
                role="button"
                onKeyDown={() => {}}
                tabIndex={0}
              >
                Plus +
              </span>
            )}
          </>
        )}
      </Box>
    </Drawer>
  ) : null;
}

const useStyles = makeStyles((theme) => ({
  search: {
    backgroundColor: "#F2F2F2",
    border: "none",
    borderRadius: 8,
    padding: "4px 10px",
    fontSize: 16,
    color: "#ABABAB",
    fontFamily: theme.typography.fontFamily,
    margin: "0 0 16px",
    width: "100%",
    outline: "none",
  },
  expandButton: { cursor: "pointer" },
  title: {
    color: theme.palette.text.secondary,
    fontWeight: "bold",
    fontSize: 17,
    marginBottom: 16,
  },
  checkbox: {
    color: theme.palette.text.greyHome,
    padding: 0,
    marginRight: 16,
    marginBottom: 4,
    height: "unset",
  },
  itemCount: {
    paddingLeft: theme.spacing(2),
  },
}));
